import React from 'react'
import { RIGHT } from '../../../constants/tabTypes'
import { IMAGE, TEXT, TITLE, MOVIE, METRO } from '../../../constants/itemTypes'
import FlyerSectionContainer from '../cont/FlyerSectionContainer'

const FormFlyerDataTab = ({
    tabs, 
    activeWeek, 
    side, 
    cinemaId, 
    printType, 
    printFormat, 
    landscape, 
    setActiveTab, 
    activeTab, 
    values, 
    flyerData, 
    basicUrl
}) => {
    const dragListConfig = [
        {
            titleTransId: 'print_flyer_heading_elements_selection',
            buttonTextTransId: 'print_flyer_new_heading',
            type: TITLE,
            itemsType: 'headlineElements',
            hasAddNewItem: true,
            hasRemoveItem: true
        },
        {
            titleTransId: 'print_flyer_text_elements_selection',
            buttonTextTransId: 'print_flyer_new_text_element',
            type: TEXT,
            itemsType: 'textElements',
            hasAddNewItem: true,
            hasRemoveItem: true
        },
        {
            titleTransId: 'print_flyer_image_elements_selection',
            buttonTextTransId: 'print_flyer_new_image_element',
            type: IMAGE,
            itemsType: 'imageElements',
            hasAddNewItem: true,
            hasRemoveItem: true
        },
        {
            titleTransId: 'print_flyer_metro_elements_selection',
            buttonTextTransId: 'print_flyer_new_metro_element',
            type: METRO,
            itemsType: 'metroElements',
            hasAddNewItem: true,
            hasRemoveItem: true
        },
        {
            titleTransId: 'section_filter_current_movies',
            buttonTextTransId: null,
            type: MOVIE,
            itemsType: 'currentMovies',
            hasAddNewItem: false,
            hasRemoveItem: false
        },
        {
            titleTransId: 'print_upcoming_movies',
            buttonTextTransId: null,
            type: MOVIE,
            itemsType: 'futureMovies',
            hasAddNewItem: false,
            hasRemoveItem: false
        }
    ]
    
    const isTitlePage = 'outside' === side && RIGHT === activeTab

    return (
        <div className={"flyertabs"}>
            <div className="standalone-tabs">
                {tabs.map(tab => {
                    const {id, title} = tab
                    const activeTabClass = activeTab === id ? "accordion-item-open" : "accordion-item-close"

                    return (
                        <div key={id} className={"selections-item header-" + activeTabClass}>
                            <h3 className="selections-item-title accordion-header site-content-wrapper-inner">
                                <button type="button" onClick={() => setActiveTab(activeTabClass, id)}><span className='title-large-light'>{title}</span></button>
                            </h3>
                        </div>
                    )
                })}
            </div>

            <FlyerSectionContainer
                dragListConfig={dragListConfig}
                values={values}
                flyerData={flyerData} 
                isTitlePage={isTitlePage}
                cinemaId={cinemaId}
                side={side} 
                section={activeTab}
                activeWeek={activeWeek}
                printType={printType}
                printFormat={printFormat}
                landscape={landscape}
                basicUrl={basicUrl}
            />
        </div>
    )
}

export default FormFlyerDataTab